import AreaPage from "@/components/AreaPage";

const area = {
  name: "Nirvana Country",
  slug: "water-tank-cleaning-nirvana-country-gurugram",
  h1: "Water Tank Cleaning in Nirvana Country, Gurugram",
  description: "Water tank cleaning in Nirvana Country Gurugram. Villas, independent floors, and luxury homes. Eco-friendly cleaning.",
  content1: "Nirvana Country is one of Gurugram's most sought-after gated communities, featuring luxury villas, independent floors, and beautifully landscaped residences near Golf Course Extension Road. TankBuddy provides premium water tank cleaning tailored for the high-end homes in Nirvana Country — handling large-capacity tanks with care and precision that matches the community's standards.",
  content2: "Residents of Nirvana Country invest in quality living, and water quality should be no exception. Our eco-friendly cleaning process uses only food-grade agents safe for families, pets, and the lush gardens that define Nirvana Country homes. We offer convenient scheduling, before/after photo documentation via WhatsApp, and periodic reminders for your next cleaning. Many Nirvana Country families trust TankBuddy for their bi-annual tank maintenance.",
  nearby: [
    { href: "/water-tank-cleaning-golf-course-road-gurugram", label: "Golf Course Road" },
    { href: "/water-tank-cleaning-sohna-road-gurugram", label: "Sohna Road" },
    { href: "/water-tank-cleaning-sector-49-50-gurugram", label: "Sector 49-50" },
    { href: "/water-tank-cleaning-sector-56-57-gurugram", label: "Sector 56-57" },
  ],
};

export default function NirvanaCountryPage() {
  return <AreaPage area={area} />;
}
